import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-23926fb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "Note: ", -1))
const _hoisted_6 = { class: "col-sm-12" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = {
  class: "list-container",
  ref: "list"
}
const _hoisted_9 = {
  key: 0,
  class: "text-center text-muted"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-muted text-center" }, "No matching results.", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick", "onKeydown"]
const _hoisted_15 = { class: "name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = {
  key: 0,
  class: "text-success text-big",
  style: {"margin-right":"10px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-ok" }, null, -1))
const _hoisted_22 = ["disabled"]

import { ref, computed, watch } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import TeamsOrGroups from "../../../typings/enums/teams-or-groups";
import {
  GroupDescriptionApiModel,
  OrganisationAndMembersApiModel,
  OrganisationGroupUpdateApiModel,
} from "../../../api-models";
import { AdminSearchResults } from "../../../views/admin/admin-search-page.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'accredited-user-area-organisation-group-add-dialog',
  setup(__props, { expose: __expose }) {

let resolveCallback: ((value: boolean) => void) | null;
let rejectCallback: ((reason?: any) => void) | null;

const errors = ref<string[]>([]);
const organisationAndMembers = ref<OrganisationAndMembersApiModel | null>(null);
const teamsOrGroups = ref<TeamsOrGroups | null>(null);
const selectedGroup = ref<GroupDescriptionApiModel | null>(null);
const searchResults = ref<GroupDescriptionApiModel[] | null>(null);
const addedGroups = ref<GroupDescriptionApiModel[]>([]);
const searchText = ref("");
const isLoading = ref(false);
const isSaving = ref(false);
const shown = ref(false);
const dialogTitle = ref("");
let serverCallTimeout: any = null;

const existingGroupIds = computed(() => {
  if (teamsOrGroups.value === TeamsOrGroups.Teams) {
    return organisationAndMembers.value?.teams
      ?.map((m) => m.group.id)
      .concat(addedGroups.value.map((u) => u.id));
  } else if (teamsOrGroups.value === TeamsOrGroups.AnalysisGroups) {
    return organisationAndMembers.value?.analysisGroups
      ?.map((m) => m.group.id)
      .concat(addedGroups.value.map((u) => u.id));
  } else {
    return organisationAndMembers.value?.groups
      ?.map((m) => m.group.id)
      .concat(addedGroups.value.map((u) => u.id));
  }
});

const filteredResults = computed(() => {
  if (!searchResults.value) {
    return null;
  }
  return searchResults.value.filter(
    (g) => !existingGroupIds.value?.includes(g.id) && !g.organisation,
  );
});

const typeName = computed(() => {
  if (teamsOrGroups.value === TeamsOrGroups.Teams) {
    return "team";
  } else if (teamsOrGroups.value === TeamsOrGroups.AnalysisGroups) {
    return "analysis group";
  } else {
    return "group";
  }
});

const close = () => {
  shown.value = false;
  if (resolveCallback) {
    resolveCallback(addedGroups.value.length > 0);
  }
};

const cancel = () => {
  close();
};

const open = (
  organisationAndMembersParam: OrganisationAndMembersApiModel,
  teamsOrGroupsParam: TeamsOrGroups,
): Promise<boolean> => {
  organisationAndMembers.value = organisationAndMembersParam;
  teamsOrGroups.value = teamsOrGroupsParam;
  selectedGroup.value = null;
  searchText.value = "";
  searchResults.value = null;
  isLoading.value = false;
  isSaving.value = false;
  serverCallTimeout = null;
  errors.value = [];
  addedGroups.value = [];
  shown.value = true;
  dialogTitle.value = `Find ${teamsOrGroupsParam === TeamsOrGroups.Teams ? "Team" : teamsOrGroupsParam === TeamsOrGroups.AnalysisGroups ? "Analysis Group" : "Group"}`;
  return new Promise((resolve, reject) => {
    resolveCallback = resolve;
    rejectCallback = reject;
  });
};

const performSearch = () => {
  if (!searchText.value || searchText.value.trim().length < 3) {
    searchResults.value = null;
    return;
  }

  if (serverCallTimeout) {
    clearTimeout(serverCallTimeout);
  }
  serverCallTimeout = setTimeout(() => {
    const query = searchText.value.trim();
    searchResults.value = [];
    selectedGroup.value = null;
    isLoading.value = true;
    serverCallTimeout = null;
    axios.get(`/admin/search/query?q=${query}`).then((resp) => {
      const searchResultsData = resp.data as AdminSearchResults;
      if (teamsOrGroups.value === TeamsOrGroups.Teams) {
        searchResults.value = searchResultsData?.Teams ?? null;
      } else if (teamsOrGroups.value === TeamsOrGroups.AnalysisGroups) {
        // Filter for analysis groups
        searchResults.value = (searchResultsData?.OtherGroups ?? []).filter(g => 
          g.groupType === 'AnalysisGroup') ?? null;
      } else {
        // Regular groups (exclude analysis groups)
        searchResults.value = (searchResultsData?.OtherGroups ?? []).filter(g => 
          g.groupType !== 'AnalysisGroup') ?? null;
      }
      isLoading.value = false;
    });
  }, 500);
};

watch(searchText, () => {
  performSearch();
});

const selectGroup = (selection: GroupDescriptionApiModel) => {
  selectedGroup.value = selection;
};

const doMove = () => {
  if (!selectedGroup.value || !organisationAndMembers.value) {
    return;
  }

  const data: OrganisationGroupUpdateApiModel = {
    groupId: selectedGroup.value.id,
    organisationId: organisationAndMembers.value.id,
  };
  isSaving.value = true;
  axios
    .post("/api/organisationgroup", data)
    .then((res) => {
      if (res.status !== 200) {
        errors.value = ["There was a problem adding the group, please try again."];
      } else {
        if (selectedGroup.value) {
          addedGroups.value.push(selectedGroup.value);
        }
        errors.value = [];
        selectedGroup.value = null;
      }
    })
    .catch((error) => {
      errors.value = ["There was a problem adding the group, please try again."];
      if (error?.response?.data?.length) {
        errors.value.push(error.response.data);
      }
    })
    .finally(() => {
      isSaving.value = false;
    });
};

async function show(organisationModel, groupType, title = null) {
  return open(organisationModel, groupType);
}

__expose({
  open,
  show,
  close,
});

return (_ctx: any,_cache: any) => {
  return (organisationAndMembers.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        class: "organisation-group-add-dialog text-left",
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shown).value = $event)),
        title: dialogTitle.value
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            (addedGroups.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(" Added " + _toDisplayString(addedGroups.value.length) + " " + _toDisplayString(typeName.value) + _toDisplayString(addedGroups.value.length > 1 ? "s" : ""), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (doMove())),
              disabled: !selectedGroup.value || isLoading.value || isSaving.value,
              type: "button"
            }, _toDisplayString(isSaving.value ? "Saving..." : "Add"), 9, _hoisted_22),
            _createElementVNode("button", {
              class: "btn btn-default btn-lg",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (cancel())),
              type: "button"
            }, "Close")
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", null, "Add " + _toDisplayString(typeName.value) + "s which do not belong to an existing organisation.", 1),
                  _createElementVNode("p", null, [
                    _hoisted_5,
                    _createTextVNode("Any members of the " + _toDisplayString(typeName.value) + "s without an organisation will also be added to ", 1),
                    _createElementVNode("b", null, _toDisplayString(organisationAndMembers.value.name), 1),
                    _createTextVNode(". ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "search",
                    class: "form-control",
                    placeholder: "Search...",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                    "aria-label": "Search"
                  }, null, 512), [
                    [_vModelText, searchText.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (filteredResults.value === null && !isLoading.value)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_9, " Search for " + _toDisplayString(typeName.value) + "s to add... ", 1))
                      : (filteredResults.value === null && isLoading.value)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_10, " Searching... "))
                        : _createCommentVNode("", true),
                    (filteredResults.value && !isLoading.value && filteredResults.value.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredResults.value, (result) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: result.id,
                        class: _normalizeClass(["group-list-item", { selected: result === selectedGroup.value }]),
                        onClick: ($event: any) => (selectGroup(result)),
                        onKeydown: _withKeys(($event: any) => (selectGroup(result)), ["enter"])
                      }, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(result.name), 1),
                        _hoisted_16,
                        (result.organisation)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["organisation label", result === selectedGroup.value ? 'label-primary' : 'label-default'])
                            }, _toDisplayString(result.organisation.name), 3))
                          : _createCommentVNode("", true)
                      ], 42, _hoisted_14))
                    }), 128))
                  ], 512)
                ])
              ])
            ]),
            (errors.value && errors.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "col-sm-12 text-danger text-left",
                        key: error
                      }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}
}

})